import React from "react";
import { useInsightState } from "../context";
import { GetOpportunitiesDataResponse } from "@/pages/explorer/types";
import { StreamingContent } from "@/modules/streaming";

interface SummaryTabProps {
  opportunity: GetOpportunitiesDataResponse;
}

export const SummaryTab: React.FC<SummaryTabProps> = ({ opportunity }) => {
  const { explanationEndpoint } = useInsightState();

  if (!explanationEndpoint) {
    return (
      <div className="al-text-center al-py-8 al-text-muted-foreground">
        Summary endpoint not configured
      </div>
    );
  }

  return (
    <div className="al-py-4">
      <StreamingContent
        id={opportunity.opportunity_id}
        endpoint={explanationEndpoint}
        requestBody={opportunity.explanation_context as Record<string, unknown> | null | undefined}
      />
    </div>
  );
};
